import React from 'react'
import PropTypes from 'prop-types';
import '../../css/components/BannerInicio/Beneficio.css';

export const Beneficio = ( { titulo, texto, urlIcono }) => {
  return (
    <div className='beneficios-inicio__beneficio'>
      <div className='beneficios-inicio__beneficio__icono'>
        <img src={urlIcono} alt="icono" />
      </div>

      <div className='beneficios-inicio__beneficio__contenido'>
        <div className='beneficios-inicio__beneficio__titulo'>
          <span>{titulo}</span>
        </div>

        <div className='beneficios-inicio__beneficio__texto'>
          <span>{texto}</span>
        </div>
      </div>
    </div>
  )
}

Beneficio.propTypes = {
  titulo: PropTypes.string.isRequired,
  texto: PropTypes.string.isRequired,
  urlIcono: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/BannerInicio/Beneficio.js